import { faUsers } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, Typography } from '@mui/material'
import { Stack } from '@vapor/material'

export type GuestCellProps = {
  mainGuestName: string
  groupName?: string
  onClick: () => void
}

export default function GuestCell({ mainGuestName, groupName, onClick }: GuestCellProps) {
  return (
    <Stack direction="column" spacing={1} paddingTop={1} paddingBottom={1}>
      <Link href="#" onClick={onClick}>
        {mainGuestName}
      </Link>
      {(groupName ? true : false) && (
        <Stack direction="row" spacing={1}>
          <FontAwesomeIcon icon={faUsers} />
          <Typography variant="caption">{groupName}</Typography>
        </Stack>
      )}
    </Stack>
  )
}
